var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { translateChoices } from '@shared/choice';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
const settings = namespace('settings');
let WaterLeakageCauseLocalizedPlumberIntervenedQuestion = class WaterLeakageCauseLocalizedPlumberIntervenedQuestion extends QuestionComponent {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get panelTitle() {
        return this.$t('step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu.panel-title');
    }
    get sidebarTitle() {
        const key = 'step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu.question-sidebar_title';
        return this.$te(key) ? this.$t(key) : this.panelTitle;
    }
    get choices() {
        return translateChoices(YES_OR_NO_CHOICES, this.$i18n.tc.bind(this.$i18n));
    }
    get answer() {
        if (this.waterDamageQualification.hasPlumberIntervened === null) {
            return null;
        }
        const key = this.waterDamageQualification.hasPlumberIntervened ? 'yes' : 'no';
        return this.$tc(`step.qualification/degat-des-eaux/fuite-localisee/plombier-intervenu.answers.${key}`);
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink);
    }
    get showHelpLink() {
        var _a, _b, _c, _d;
        if (this.hideHelpLink &&
            ((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.waterLeakageCauseLocalizedPlumberIntervened) === null || _d === void 0 ? void 0 : _d.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    updateClaim(hasPlumberIntervened) {
        this.updateAndSaveWaterDamageQualification({
            step: this.step,
            qualificationPayload: { hasPlumberIntervened },
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "waterDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "updateAndSaveWaterDamageQualification", void 0);
__decorate([
    settings.Getter('setting')
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion.prototype, "setting", void 0);
WaterLeakageCauseLocalizedPlumberIntervenedQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], WaterLeakageCauseLocalizedPlumberIntervenedQuestion);
export default WaterLeakageCauseLocalizedPlumberIntervenedQuestion;
